import React, { Suspense, lazy } from 'react';
import { Router } from '@reach/router';
import { GlobalStyles } from './styled/styledComponents';
import NavigationList from './components/NavigationList';
import './assets/styles/index.scss';
import Provider from './contexts/Provider';
import Loading from './components/Loading';
const Cover = lazy(() => import('./routes/homepage/Cover'));
const Features = lazy(() => import('./routes/homepage/Features'));
const PartnerLists = lazy(() => import('./routes/homepage/Partners'));
const Footer = lazy(() => import('./routes/homepage/Footer'));
const L2E = lazy(() => import('./routes/homepage/L2E'));
const HowToEarnCoins = lazy(() => import('./routes/homepage/HowToEarnCoins'));
const About = lazy(() => import('./routes/homepage/About'));
const TermsAndConditions = lazy(() => import('./routes/terms-and-conditions'));
const PrivacyPolicy = lazy(() => import('./routes/privacy-policy'));
const CourseDescription = lazy(() =>
  import('./routes/homepage/CourseDescription')
);
const Courses = lazy(() => import('./routes/courses'));
const Partners = lazy(() => import('./routes/partners'));

function App() {
  return (
    <>
      <Provider>
        <Suspense fallback={<Loading />}>
          <GlobalStyles />
          <Router primary={false}>
            <NavigationList path="/">
              <Cover path="/" />
            </NavigationList>
          </Router>
          <Router primary={false}>
            <Partners path="education_partners" />
            <Courses path="courses" />
          </Router>
          <Router primary={false}>
            <TermsAndConditions path="terms-and-conditions" />
          </Router>
          <Router primary={false}>
            <PrivacyPolicy path="privacy-policy" />
          </Router>
          <div className="app-background">
            <Router primary={false}>
              <CourseDescription path="/" />
            </Router>
            <Router primary={false}>
              <Features path="/" />
            </Router>
            <Router primary={false}>
              <L2E path="/" />
            </Router>
            <Router primary={false}>
              <HowToEarnCoins path="/" />
            </Router>
            <Router primary={false}>
              <PartnerLists path="/" />
            </Router>
            <Router primary={false}>
              <About path="/" />
            </Router>
          </div>
          <Router primary={false}>
            <Footer path="/" />
          </Router>
        </Suspense>
      </Provider>
    </>
  );
}

export default App;
